import React from 'react';
import PropTypes from 'prop-types';

import { Box, Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { isEmpty, map } from 'lodash';
import TutorialModal from './TutorialModal';

import { useStyles } from '../../../styles/mapStylesCustom';

const HomeMaps = props => {
  const { userControlSetting } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const [propertiesToPass, setPropertiesToPass] = React.useState([]);
  const isMobile = window.innerWidth < 500;

  const classes = useStyles();

  return (
    <>
      {!isEmpty(userControlSetting) && !isEmpty(userControlSetting.tutorial) && (
        <Box
          display="flex"
          justifyContent="center"
          flexDirection={isMobile ? 'column' : 'row'}
          style={{ marginTop: '5%' }}
        >
          {map(userControlSetting.tutorial, item => {
            return (
              <>
                {isMobile === true ? (
                  <Card
                    sx={{ display: 'flex', borderRadius: 4, margin: 'auto', mb: 2 }}
                    key={item.title}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography component="div" variant="h6">
                          {item.title}
                        </Typography>
                        <Typography color="text.secondary" component="div" variant="subtitle1">
                          {item.description}
                        </Typography>
                      </CardContent>
                      <Box sx={{ alignItems: 'center', display: 'flex', pl: 1, pb: 1 }}>
                        <Button
                          className={classes.azulIpsilumButton}
                          size="small"
                          onClick={() => {
                            setPropertiesToPass(item.properties);
                            setOpenModal(true);
                          }}
                        >
                          Tutorial
                        </Button>
                      </Box>
                    </Box>
                    <CardMedia
                      sx={{ flex: '0 0 auto', width: '50%', backgroundSize: 'cover' }}
                      image={item.imagen}
                      title={item.title}
                    />
                  </Card>
                ) : (
                  <Card
                    sx={{
                      maxWidth: isMobile ? '40%' : '15%',
                      borderRadius: 4,
                      margin: 'auto'
                    }}
                  >
                    <CardMedia
                      sx={{ height: 0, paddingTop: '100%', width: '100%' }}
                      image={item.imagen}
                      title={item.title}
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h6" component="div">
                        {item.title}
                      </Typography>
                      <Typography variant="body2" style={{ color: '#000000' }}>
                        {item.description}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: 'center' }}>
                      <Button
                        size="small"
                        className={classes.azulIpsilumButton}
                        onClick={() => {
                          setPropertiesToPass(item.properties);
                          setOpenModal(true);
                        }}
                      >
                        Tutorial
                      </Button>
                    </CardActions>
                  </Card>
                )}
                <TutorialModal
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                  properties={propertiesToPass}
                />
              </>
            );
          })}
        </Box>
      )}
    </>
  );
};
HomeMaps.defaultProps = {
  userControlSetting: {}
};
HomeMaps.propTypes = {
  userControlSetting: PropTypes.object
};

export default HomeMaps;
